import {QueryClient} from "@tanstack/react-query";
import {createTRPCClient, httpBatchLink} from "@trpc/client";
import {createTRPCOptionsProxy} from "@trpc/tanstack-react-query";
import type {AppRouter} from "@chayka/trpc";
import {env} from "@/lib/env";

export const queryClient = new QueryClient();

const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${env.VITE_API_URL}/trpc`,
      fetch: (url, options) =>
        fetch(url, {
          ...options,
          credentials: "include",
          cache: "no-store",
        }),
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});
